import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PodcastClientServicesService } from '../podcast-client-api';
import { HelpersService } from '../../core/helpers/helpers.service';
import { Observable } from 'rxjs';
import { PodcastGroup, Podcast } from '../podcast-client-api/model/podcastContent';
import { PodcastContentClientServicesService } from '../podcast-content-client-api';

@Injectable()
export class PodcastDataRestService {

  constructor(
    private http: HttpClient,
    private restPodcast: PodcastClientServicesService,
    private restPodcastContent: PodcastContentClientServicesService,
    helpers: HelpersService
    ) { 
    }


    getPodcastGroups(): Observable<PodcastGroup[]> {
      return this.restPodcast.getPodcatsGroupWithPodcatsUsingGET().map(response => {
        if (response.code == 200) {
          return response.data;
        }
        else {
          return false;
        }
      })
    }

    
    getPodcasts(podcastID: number): Observable<Podcast> {
      return this.restPodcast.getPodcastWithPodcatsContentUsingGET(podcastID).map(response => {
        if (response.code == 200) {
          return response.data;
        }
        else {
          return false;
        }
      })
    }

    getPodcastGroupById(podcastGroupID: number): Observable<PodcastGroup> {
      return this.restPodcast.getPodcastGroupByID(podcastGroupID).map(response => {
        if (response.code == 200) {
          return response.data;
        }
        else {
          return false;
        }
      })
    }

    likePodcastContent(podcastContentID: number): Observable<any> {
      return this.restPodcastContent.likePodcastContentUsingGET(podcastContentID).map(response => {
        if (response.code == 200) {
          return true;
        }
        else {
          return false;
        }
      })
    }
    
    dislikePodcastContent(podcastContentID: number): Observable<any> {
      return this.restPodcastContent.dislikePodcastContentUsingGET(podcastContentID).map(response => {
        return response;
      })
    }
    
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/podcast/podcast-data-rest.service.ts